import { PAYMENT_API_FIELDS, PAYMENT_BO_FIELDS, PAYMENT_CALLBACKS } from './providerConfiguration';

export const isPaymentGatewayTicket = ticket => ticket.ticket_type === 'l1_create' ? ticket.l1_request?.module === 'payment_gateway_master_providers' : ticket.provider_kind === 'payment_gateway';
export const getTicketProviderDefinition = (provider, paymentGateway, fields = []) => !provider || !paymentGateway ? provider : {
  ...provider,
  paymentGateway: true,
  ...Object.fromEntries(['category', 'country', 'currency'].map(key => {
    const values = Array.isArray(provider[key]) ? provider[key] : provider[key] ? [provider[key]] : [];
    return [key, values.map(value => fields.find(field => field.key === key)?.options?.find(option => option._id === (value?._id || value)) || value)];
  })),
  api_credential_keys: PAYMENT_API_FIELDS,
  bo_credential_keys: PAYMENT_BO_FIELDS,
  callback_urls: PAYMENT_CALLBACKS,
  group_links: provider.group_links || []
};

export const isProviderInformationRequest = ticket => ticket.ticket_type === 'change_provider' && !ticket.provider_change?.is_upline_change;
export const isCollaborativeProviderRequest = ticket => ticket.ticket_type === 'add_provider' || isProviderInformationRequest(ticket);
export const isCollaborativeTicket = ticket => ticket.ticket_type === 'l1_create' || isCollaborativeProviderRequest(ticket);

export const buildTicketActionPayload = (ticket, action, form) => {
  const payload = action.type === 'collaboration' ? { mode: action.mode } : { action: action.key };
  if (isCollaborativeTicket(ticket)) payload.expected_revision = ticket.request_revision || 0;
  if (form.assigned_to_user) payload.assigned_to_user = form.assigned_to_user;
  if (action.can_select_route) {
    if (action.type !== 'collaboration') payload.stage = form.stage || ticket.stage;
    payload.status = form.status || ticket.status;
  }
  if (action.requires_note && form.note?.trim()) payload.note = form.note.trim();
  return payload;
};
